import React, { MouseEvent, useState } from 'react';
import { CheckBox } from 'kb-web-shared';
import PaymentTerms from '../../../components/Billing/components/TermsModal';
import {
  CheckboxContainer,
  EmployeeAttestation,
  Separator,
  EnterpriseTermsBlock,
  TermsInnerContainer,
  TermsLink,
  TermsText,
  TermsTextContainer,
  TextContainer
} from './TermsDetails.common-styled';

type EnterpriseMembershipTermsDetailsProps = {
  selected: boolean;
  onCheckBoxSelected: (e: MouseEvent<HTMLDivElement>) => void;
  type?: 'emailAndCredit' | 'credit';
};

type State = {
  modalVisible: boolean;
};

const EnterpriseMembershipTermsDetails = (props: EnterpriseMembershipTermsDetailsProps) => {
  const [state, setState] = useState<State>({
    modalVisible: false
  });

  const showPaymentTerms = () => {
    setState({
      modalVisible: true
    });
  };
  const { selected, onCheckBoxSelected, type = 'emailAndCredit' } = props;

  return (
    <EnterpriseTermsBlock>
      <PaymentTerms
        show={state.modalVisible}
        onAgree={() => {
          setState({
            modalVisible: false
          });
        }}
        onClose={() => {
          setState({
            modalVisible: false
          });
        }}
      />
      <TermsInnerContainer>
        <CheckboxContainer>
          <CheckBox selected={selected} onSelect={onCheckBoxSelected} />
        </CheckboxContainer>
        <TextContainer>
          {type === 'emailAndCredit' && (
            <TermsTextContainer>
              <TermsText>
                I authorize Kindbody to send me secure communications, which may include my medical
                information. Kindbody only sends unencrypted text messages for appointment reminders
                and portal notifications. I have also read and acknowledged the employee or
                spouse/partner attestation below.
              </TermsText>
            </TermsTextContainer>
          )}
        </TextContainer>
      </TermsInnerContainer>
      <EmployeeAttestation>
        <p>Employee or Spouse/Partner Attestation:</p>
        <p>
          If I am an employee, I understand my employer offers the Kindbody family-building benefit
          and I am eligible to participate in this benefit so long as I am enrolled in my
          employer&apos;s group medical plan or I am enrolled in another employer&apos;s group
          medical plan that provides “minimum value” coverage pursuant to Internal Revenue Code
          Section 36B(c)(2)(C)(ii). Typically, if I am enrolled in my spouse or partner&apos;s group
          medical plan or an individual-market plan, that plan meets the definition above and I can
          check with the plan to confirm. By clicking the &lsquo;Submit&rsquo; button below, I
          hereby attest that I am either enrolled in my employer&apos;s group medical plan or I am
          enrolled in a qualifying group medical plan (e.g., through my spouse, partner or an
          individual-market plan). OR
        </p>
        <p>
          If I am a spouse/partner, I understand my spouse or partner&apos;s employer offers the
          Kindbody family-building benefit. I am either eligible to enroll in the Kindbody benefit
          because of: (i) my enrollment in my spouse or partner&apos;s medical plan, or (ii) if I am{' '}
          <u>not</u> enrolled in my spouse or partner&apos;s medical plan, I am enrolled in another
          group health plan that provides “minimum value” coverage pursuant to Internal Revenue Code
          Section 36B(c)(2)(C)(ii). Typically, if I am enrolled in my employer&apos;s group medical
          plan or an individual-market plan, that plan meets the definition above and I can check
          with the plan to confirm. By clicking the &lsquo;Submit&rsquo; button below, I hereby
          attest that I am either enrolled in my employer&apos;s group medical plan or I am enrolled
          in a qualifying group medical plan (e.g., through my spouse, partner or an
          individual-market plan).
        </p>
        <p>
          <i>
            Note: This attestation does not apply if I am <u>only</u> enrolling in the Kindbody
            third party or adoption services benefit.
          </i>
        </p>
      </EmployeeAttestation>
      <Separator />
      <TextContainer>
        <TermsTextContainer>
          <TermsText>
            By clicking the button below, I agree that I have read and accept Kindbody’s{' '}
            <TermsLink href="/terms-of-service/" target="_blank" rel="noopener noreferrer">
              Terms of Use
            </TermsLink>
            ,{' '}
            <TermsLink
              href="https://kindbody.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </TermsLink>
            ,{' '}
            <TermsLink
              href="https://kindbody.com/notice-of-privacy-practices/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Notice of Privacy Practices
            </TermsLink>{' '}
            and <TermsLink onClick={showPaymentTerms}>Payment Terms.</TermsLink>
          </TermsText>
        </TermsTextContainer>
      </TextContainer>
    </EnterpriseTermsBlock>
  );
};

export default EnterpriseMembershipTermsDetails;
